<div class="row mt-4 align-items-center ocultar-mobile">
  <div class="col- mt-4">
    <a
      class="cursor-pointer btn-volver"
      (click)="validarVolver()"
      data-toggle="tooltip"
      data-placement="top"
      title="VOLVER"
      alt="VOLVER"
    >
      <i class="bi bi-chevron-left mr-2"></i>
      Volver
    </a>
  </div>
  <div class="col-10">
    <h1 class="text-center">Registro de calificaciones</h1>
  </div>
</div>

<div
  class="alert alert-success alert-dismissible tipografía_alertas mt-4 mb-4"
  role="alert"
  *ngIf="alineacionRealizada"
>
  <i class="bi bi-check-circle-fill tamanio_iconos-boton mr-2"></i> {{tipoAlineacion === 'Validar' ? 'Alineación confirmada': 'Alineación realizada'}}
  <button type="button" class="close" data-dismiss="alert" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="mostrar-info-seccion" *ngIf="tablaCalificaciones?.body">
  <!-- INFORMACIÓN DE PLANILLA -->
  <div class="cuadrado_gris mt-5 mb-2 ocultar-mobile">
    <div class="row mt-3 mx-3">
      <div class="col-6 custom-border-info">
        <p>
          Asignatura: <strong>{{ asignatura?.asignatura }}</strong>
        </p>
        <p>
          Periodo: <strong>{{ asignatura?.periodo }}</strong>
        </p>
        <p>
          Sede: <strong>{{ asignatura?.sede }}</strong>
        </p>
      </div>
      <div class="col-6">
        <p>Docente(s):</p>
        <p class="text-uppercase" *ngFor="let docente of docentes">
          <strong>{{ docente.docente }}</strong>
        </p>
      </div>
    </div>
  </div>
  <!-- FIN INFORMACIÓN DE PLANILLA -->
  <div class="d-flex content-left-buttons ocultar-mobile float-left">
  <span class="ocultar-mobile d-block mb-4"
    >* Los cambios se guardan automáticamente a medida que los realizas. Sin
    embargo, si lo prefieres, también puedes hacer clic en el botón 'Guardar'
    para confirmar los cambios manualmente.</span
  >
  <!-- FIN INFORMACIÓN DE PLANILLA -->
  <!-- <br><br> -->
    <button
      class="boton-secundario disabledObtenerCalificaciones ocultar-mobile alineacionDisponible-btn"
      title="Alineación con calificaciones de Blackboard disponible"
      alt="Alineación con calificaciones de Blackboard disponible"
      *ngIf="
        datosAlineacion.estadoAlineacion === 'Configurar' ||
        datosAlineacion.estadoAlineacion === 'Validar'
      "
      (click)="navegarAlineacion()"
    >
      Alineación con calificaciones de Blackboard disponible
    </button>
    <div
      class="btnContainer ocultar-mobile"
      *ngIf="mostrarObtenerCalificaciones()"
    >
      <button
        (click)="mostrarModalIntegracionBb()"
        class="boton-secundario disabledObtenerCalificaciones"
        title="Obtener calificaciones de blackboard"
        alt="Obtener calificaciones de blackboard"
        [disabled]="btnObtenerCalificacionesDeshabilitado"
      >
        Obtener calificaciones de blackboard
      </button>

      <div *ngIf="btnObtenerCalificacionesDeshabilitado">
        <div id="icono-periodo">
          <i class="bi bi-info-circle"></i>
        </div>
        <div class="triangle"></div>
        <div [id]="'cstm-popover'" class="cstm-popover arrow_box">
          No se encontró el curso en Blackboard para poder realizar esta
          sincronización.
        </div>
      </div>
    </div>
    <div
      *ngIf="!mostrarBtnObtenerCalificaciones"
      style="margin-bottom: -5em"
      class="mt-3 ocultar-mobile"
    >
      <p>
        <b>Calificaciones Blackboard integradas:</b><br />
        ID curso Blackboard: <br />
        {{ idCursoBlackboard }}
      </p>
    </div>
  </div>
  <!-- <br><br> -->
  <div class="d-flex content-right-buttons ocultar-mobile float-right">
    <div class="d-flex mb-4">
      <label
        class="titulo_criterios ocultar-mobile"
        for="exampleFormControlSelect2"
        >Buscar:
      </label>
      <div class="input-group mb-5 ocultar-mobile">
        <input
          [(ngModel)]="nombreRutAlumnoFiltro"
          (ngModelChange)="changeFiltro()"
          type="text"
          class="form-control select_criterios mx-3"
          placeholder="Nombre o RUT"
          aria-describedby="basic-addon2"
        />
      </div>
    </div>
    <button
      class="boton-secundario w-button-eval"
      title="Configurar fechas de evaluaciones"
      alt="Configurar fechas de evaluaciones"
      data-toggle="modal"
      data-target="#fechaEvaluaciones"
      *ngIf="datosListaEvaluaciones.length > 0"
    >
      Configurar fechas de evaluaciones
    </button>
  </div>
  <!-- TABLA NOTAS -->
  <!-- table-striped -->
  <div class="tabla-calificaciones">
    <table
      *ngIf="renderTablaCalificaciones"
      datatable
      [dtOptions]="dtOptions"
      class="row-border hover ocultar-mobile"
      aria-describedby="tabla secciones"
    >
      <thead>
        <tr class="header_tabla">
          <th
            class="th-tabla-calificaciones"
            [ngClass]="{
              'width-pond': i > 2 && !last,
              'text-center': i !== 1 && i !== 2 && !last,
              'header-CF': header.valor === 'CF',
              'header-CP_CE':
                header.valor !== 'Anotaciones' &&
                header.valor !== 'Nº' &&
                header.valor !== 'RUT' &&
                header.valor !== 'Nombre' &&
                header.valor !== 'CF' &&
                header.valor !== 'Situación final' &&
                !header.editable,
              'th-anotaciones': last || i === 2 || i === 1
            }"
            *ngFor="
              let header of tablaCalificaciones?.headers;
              let i = index;
              let first = first;
              let last = last
            "
            [matTooltip]="getTooltipFechaHeader(header)"
            [matTooltipDisabled]="!hasFecha(header)"
            matTooltipPosition="above"
            [matTooltipClass]="'tooltip-fecha'"
            matTooltipShowDelay="120"
            matTooltipHideDelay="0"
          >
            {{ header.valor }}
            <div
              class="check-integracion-bb"
              (mouseenter)="toggleDescripcionBb(i)"
              (mouseleave)="toggleDescripcionBb(i)"
              *ngIf="
                (header.tipoNota === 'CP' || header.tipoNota === 'CE') &&
                header.columanBb
              "
            >
              <i
                class="bi"
                [ngClass]="{
                  'bi-check-circle-fill': header.columanBb.ultimaActualizacion,
                  'bi-check-circle': !header.columanBb.ultimaActualizacion || header.columanBb.errorFormato || header.columanBb.notasVacias,
                  'bi-exclamation-triangle': header.columanBb.encontradaBb === false
                }"
              ></i>
              <div
                [id]="'check-integracion-container-' + i"
                class="check-integracion-container d-none"
              >
                <div class="descripcion-calificacion-bb" *ngIf="header.columanBb?.encontradaBb !== false">
                  <span>Calificación alineada con Blackboard</span>
                  <p class="mb-0" [title]="header.columanBb.nombreColumnaBB">
                    {{ header.columanBb.nombreColumnaBB }}
                  </p>
                  <span>({{ header.columanBb.puntosBB }} Puntos)</span>
                  <div *ngIf="header.columanBb?.ultimaActualizacion">
                    <div class="separador"></div>
                    <span
                      >Última actualización:
                      {{
                        header.columanBb.ultimaActualizacion
                          | date : "dd/MM/yyyy HH:mm"
                      }}</span
                    ><br />
                    <span
                      >Cantidad de registros:
                      {{ header.columanBb.cantidadCalificacionesActualizadas }}
                      de {{ header.columanBb.cantidadTotalCalificaciones }}</span
                    >
                  </div>
                </div>
                <div class="descripcion-calificacion-bb text-center"  *ngIf="header.columanBb?.encontradaBb === false">
                  <span>La columna previamente alineada,<br />no se encuentra
                    disponible en Blackboard.</span>
                </div>
              </div>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <ng-container
          *ngFor="
            let body of tablaCalificaciones?.body
              | filtroAlumnos : nombreRutAlumnoFiltro;
            let indexBody = index
          "
        >
          <tr *ngIf="body.visible">
            <td
              *ngFor="let row of body.row; let i = index; let last = last"
              [ngClass]="{ 'text-center': i !== 1 && i !== 2 && !last }"
            >
              <ng-container
                *ngIf="tablaCalificaciones?.headers?.[i]?.valor === 'Anotaciones'"
              >
                <textarea
                  class="form-control"
                  id="exampleFormControlTextarea1"
                  maxlength="150"
                  placeholder="Máx. 150 carácteres"
                  rows="2"
                  style="font-size: 1.2rem"
                  [value]="row.valor"
                  [disabled]="!row.editable || !registrosEditables || tablaCalificaciones?.headers?.[i]?.editable === false"
                  (input)="modificarAnotaciones(indexBody, i, row, $event)"
                  (focusout)="focusOut($event, indexBody, i, row, true)"
                >
                </textarea>
              </ng-container>
              <ng-container
                *ngIf="tablaCalificaciones?.headers?.[i]?.valor !== 'Anotaciones' && tablaCalificaciones?.headers?.[i]?.valor !== 'Nº' && tablaCalificaciones?.headers?.[i]?.valor !== 'RUT' && tablaCalificaciones?.headers?.[i]?.valor !== 'Nombre' && tablaCalificaciones?.headers?.[i]?.valor !== 'CF' && tablaCalificaciones?.headers?.[i]?.valor !== 'Situación final'"
              >
                <input
                  [disabled]="!row.editable || !registrosEditables || tablaCalificaciones?.headers?.[i]?.editable === false"
                  type="text"
                  class="form-control text-center input_ingreso_nota"
                  [id]="'input-calificacion-' + indexBody + '-' + i"
                  [value]="row.valor"
                  (input)="modificarCalificacion(indexBody, i, row, $event)"
                  (keypress)="
                    allowNumericDigitsOnlyOnKeyUp($event, indexBody, i, row)
                  "
                  (keyup)="keyUpCalificacion($event, indexBody, i, row)"
                  (focus)="focusIn($event, indexBody, i, row)"
                  (focusout)="focusOut($event, indexBody, i, row)"
                  onpaste="return false;"
                />
              </ng-container>
              <ng-container
                *ngIf="tablaCalificaciones?.headers?.[i]?.valor !== 'Anotaciones' && tablaCalificaciones?.headers?.[i]?.valor === 'Nº' || tablaCalificaciones?.headers?.[i]?.valor === 'RUT' || tablaCalificaciones?.headers?.[i]?.valor === 'Nombre' || tablaCalificaciones?.headers?.[i]?.valor === 'CF' || tablaCalificaciones?.headers?.[i]?.valor === 'Situación final'"
              >
                <strong *ngIf="tablaCalificaciones?.headers?.[i]?.valor === 'CF'">
                  {{ row.valor ? row.valor : "-" }}
                </strong>
                <ng-container
                  *ngIf="tablaCalificaciones?.headers?.[i]?.valor !== 'CF'"
                >
                  {{ row.valor ? row.valor : "-" }}
                </ng-container>
              </ng-container>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
  <!-- FIN TABLA NOTAS -->

  <div class="row align-items-center mt-5 ocultar-mobile">
    <div class="col mb-4 text-left" *ngIf="registrosEditables">
      <button
        id="btn-cerrar-curso-visualizacion-seccion"
        (click)="cerrarSeccion()"
        class="boton-secundario mt-2 btn-cerrar-curso"
        data-toggle="tooltip"
        data-placement="top"
        title="CERRAR CURSO"
        alt="CERRAR CURSO"
        *ngIf="tablaCalificaciones?.body"
      >
        CERRAR CURSO
      </button>
    </div>
    <div class="col-4">
      <button
        class="btn boton_descargar_registro_calificacion mb-3"
        (click)="descargarRegistroCalificaciones()"
        *ngIf="tablaCalificaciones?.body"
      >
        <i class="bi bi-filetype-xlsx tamanio_iconos-boton mr-3"></i>
        <strong>Descargar registro de calificaciones </strong>(Excel)
      </button>
    </div>
    <div class="col mb-4" *ngIf="!registrosEditables && mostrarActa">
      <button
        id="btn-descargar-acta-visualizacion-seccion"
        class="boton-secundario mt-2 custom-ml-8-per"
        data-toggle="tooltip"
        data-placement="top"
        title="DESCARGAR ACTA"
        alt="DESCARGAR ACTA"
        (click)="
          descargarActa(
            configuracion.seccionId,
            configuracion.anyo,
            configuracion.periodoId
          )
        "
      >
        <i class="bi bi-filetype-pdf tamanio_iconos-boton mr-3"></i>
        DESCARGAR ACTA
      </button>
    </div>
  </div>

  <div class="row ocultar-desktop">
    <div class="col">
      <div
        *ngIf="alertaExito !== ''"
        class="alert alert-success alerta_calificaciones alerta_calificaciones_mobile tipografía_alertas alerta_mobile"
        role="alert"
      >
        <i class="bi bi-check2-circle tamanio_iconos-boton mr-2"></i
        >{{ alertaExito }}
      </div>
    </div>
  </div>

  <div class="row align-items-center ocultar-mobile">
    <div class="col">
      <div
        *ngIf="alertaExito !== ''"
        class="alert alert-success alerta_calificaciones tipografía_alertas alerta_mobile"
        role="alert"
      >
        <i class="bi bi-check2-circle tamanio_iconos-boton mr-2"></i
        >{{ alertaExito }}
      </div>
    </div>
    <div class="col-2">
      <button
        *ngIf="registrosEditables && tablaCalificaciones?.body"
        class="boton-primario boton-grabar"
        data-toggle="tooltip"
        data-placement="top"
        title="GUARDAR"
        alt="GUARDAR"
        id="btn-guardar-visualizacion-seccion"
        (click)="guardarCalificaciones()"
        [disabled]="loadingAutoguardado"
      >
        guardar
        <div *ngIf="loadingAutoguardado" class="spinning-autoguardado">
          <i class="bi bi-arrow-clockwise"></i>
        </div>
      </button>
    </div>
  </div>
  <!-- ALERTA DE GUARDADO -->

  <!-- MODAL CERRAR CURSO -->
  <button
    id="modal-confirmar-cierre-seccion"
    class="btn d-none"
    data-toggle="modal"
    data-target="#confirmar"
  >
    CERRAR CURSO 1
  </button>
  <div
    class="modal fade"
    id="confirmar"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header align-items-center">
          <h1 class="modal-title mt-0 ml-4" id="exampleModalLabel">Atención</h1>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            title="CERRAR"
            alt="CERRAR"
          >
            <div class="icono-cerrar mr-3" aria-hidden="true">&times;</div>
          </button>
        </div>
        <div class="modal-body">
          <form>
            <div class="row align-items-center my-3 mx-4">
              <p class="mb-0 ml-3">
                ¿Estás seguro/a que deseas cerrar el curso?
              </p>
              <span class="ml-3 mt-2"
                >Al presionar botón ‘SI’, no podrás realizar
                modificaciones.</span
              >
            </div>
          </form>
        </div>
        <div class="modal-footer justify-content-center">
          <div class="my-4">
            <button
              id="btn-cancelar-cierre-seccion-visualizacion-seccion"
              class="boton_secundario_modal ml-3"
              data-toggle="tooltip"
              data-placement="top"
              title="NO"
              alt="NO"
              data-dismiss="modal"
              id="btn-cerrar-modal-cierre-seccion"
            >
              NO
            </button>
            <button
              id="btn-confirmar-cierre-seccion-visualizacion-seccion"
              class="boton-primario boton-primario-modificado ml-3"
              data-toggle="tooltip"
              data-placement="top"
              title="SI"
              alt="SI"
              (click)="confirmarCierreSeccion()"
            >
              SI
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- FIN MODAL CERRAR CURSO -->

  <!-- MODAL SIN INGRESO DE CALIFICACIÓN -->
  <button
    id="modal-estudiantes-sin-calificaciones"
    class="btn d-none"
    data-toggle="modal"
    data-target="#confirmar2"
  >
    CERRAR CURSO 2
  </button>
  <div
    class="modal fade"
    id="confirmar2"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header align-items-center">
          <h1 class="modal-title mt-0 ml-4" id="exampleModalLabel">Atención</h1>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            title="CERRAR"
            alt="CERRAR"
          >
            <div class="icono-cerrar mr-3" aria-hidden="true">&times;</div>
          </button>
        </div>
        <div class="modal-body">
          <form>
            <div class="row align-items-center my-3 mx-4">
              <p class="mb-0 ml-3">
                No puedes cerrar el curso, ya que aún hay estudiantes sin
                ingreso de calificación.
              </p>
              <span class="ml-3 mt-2"
                >Las celdas no deben contener calificación 0,0.</span
              >
            </div>
          </form>
        </div>
        <div class="modal-footer justify-content-center">
          <div class="my-4">
            <button
              class="boton_secundario_modal ml-3"
              data-toggle="tooltip"
              data-placement="top"
              title="Aceptar"
              alt="Aceptar"
              data-dismiss="modal"
            >
              Aceptar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- FIN MODAL SIN INGRESO DE CALIFICACIÓN -->

  <!-- ///////////////////////////////////////////////////////////// -->

  <!-- MOBILE & TABLET -->
  <div class="col-12 mt-0 ml-0 pl-0 mb-3 ocultar-desktop">
    <a
      class="cursor-pointer color-negro btn-volver"
      (click)="validarVolver()"
      data-toggle="tooltip"
      data-placement="top"
      title="VOLVER"
      alt="VOLVER"
    >
      <i class="bi bi-chevron-left mr-2"></i>
      Volver
    </a>
  </div>
  <h1 class="ocultar-desktop">Registro de calificaciones</h1>

  <div class="row d-flex justify-content-center mt-5 ocultar-desktop">
    <button
      *ngIf="registrosEditables"
      class="boton-primario ocultar-desktop"
      data-toggle="tooltip"
      data-placement="top"
      title="INGRESAR CALIFICACIONES"
      alt="INGRESAR CALIFICACIONES"
      (click)="ingresoCalificacionesMobile()"
    >
      ingresar calificaciones
    </button>
  </div>
  <div class="row cstm-btns-w-95 text-center ocultar-desktop">
    <!-- Sección cerrada -->
    <button
      *ngIf="!registrosEditables && mostrarActa"
      class="boton-secundario mt-2 btn-block btn-acta-mobile"
      data-toggle="tooltip"
      data-placement="top"
      title="DESCARGAR ACTA"
      alt="DESCARGAR ACTA"
      id="btn-descargar-acta-visualizacion-seccion-mobile"
      (click)="
        descargarActa(
          configuracion.seccionId,
          configuracion.anyo,
          configuracion.periodoId
        )
      "
    >
      <i class="bi bi-filetype-pdf tamanio_iconos-boton mr-3"></i>
      DESCARGAR ACTA
    </button>
    <button
      *ngIf="!registrosEditables"
      class="boton-secundario mt-4 btn-block"
      id="btn-descargar-registro-calificaciones-visualizacion-seccion-mobile"
      (click)="descargarRegistroCalificaciones()"
    >
      <i class="bi bi-filetype-xlsx tamanio_iconos-boton mr-3"></i>
      <strong>registro de calificaciones</strong>
    </button>
  </div>

  <!-- DATOS SECCIÓN -->
  <div
    class="py-2 my-5 borde_inferior_datos_secciones borde_superior_datos_secciones ocultar-desktop"
  >
    <p class="mb-1 mt-3 text-uppercase">{{ asignatura?.asignatura }}</p>
    <p class="mb-1 text-uppercase">{{ asignatura?.periodo }}</p>
    <p class="mb-1 text-uppercase" *ngFor="let docente of docentes">
      {{ docente.docente }}
    </p>
    <p class="mb-3 text-uppercase">{{ asignatura?.sede }}</p>
  </div>
  <!-- FIN SECCIÓN -->

  <!-- BUSCAR -->

  <label
    class="titulo_criterios mx-3 ocultar-desktop"
    for="exampleFormControlSelect2"
    >Buscar</label
  >
  <div class="input-group mb-5 ocultar-desktop">
    <input
      [(ngModel)]="nombreRutAlumnoFiltro"
      type="text"
      class="form-control select_criterios mx-3"
      placeholder="Nombre o RUT"
      aria-describedby="basic-addon2"
    />
  </div>
  <!-- FIN BUSCAR -->

  <!-- ALUMNOS -->

  <ng-container
    *ngFor="
      let body of tablaCalificaciones?.body
        | filtroAlumnos : nombreRutAlumnoFiltro;
      let indexBody = index
    "
  >
    <!-- borde_superior_datos_secciones -->
    <div class="borde_inferior_datos_secciones fondo_gris ocultar-desktop">
      <div class="row">
        <div class="col-9 col-sm-10 col-md-10 col-lg-11">
          <p class="mb-0 mx-5 pt-3 datos_alumnos-suspensivo">
            <strong>{{ body.row[getHeaderIndexByKey("Nombre")].valor }}</strong>
          </p>
        </div>
        <div class="col">
          <button
            (click)="collapseAlumno(indexBody)"
            class="btn btn-desplegar"
            data-toggle="collapse"
            [attr.data-target]="'#collapseAlumno-' + indexBody"
            aria-expanded="false"
            aria-controls="collapseAlumno"
          >
            <i
              [ngClass]="
                alumnoCollapsed(indexBody) ? 'bi-plus-circle' : 'bi-dash-circle'
              "
              class="bi tamanio_iconos-boton ml-3"
            ></i>
          </button>
        </div>
      </div>
      <span class="mx-5 datos_alumnos-RUT">{{
        body.row[getHeaderIndexByKey("RUT")].valor
      }}</span>
      <p class="mx-5 mt-2 pb-3 datos_alumnos-textoCalificacionFinal">
        CALIFICACIÓN FINAL
        <strong class="datos_alumnos-calificacionFinal ml-2"
          >{{ body.row[getHeaderIndexByKey("CF")].valor }}
          {{
            body.row[getHeaderIndexByKey("Situación final")].valor ? "- " : ""
          }}
          {{
            body.row[getHeaderIndexByKey("Situación final")].valor ??
              body.row[getHeaderIndexByKey("Situación final")].valor
          }}</strong
        >
      </p>

      <div
        class="collapse ocultar-desktop bg-color-white"
        [id]="'collapseAlumno-' + indexBody"
      >
        <!-- borde_inferior_datos_secciones -->
        <div class="mt-4 mx-4 ocultar-desktop">
          <div
            class="row"
            *ngFor="
              let row of body.row;
              let i = index;
              let last = last;
              let first = first
            "
          >
            <ng-container
              *ngIf="tablaCalificaciones?.headers?.[i]?.valor !== 'Anotaciones' && tablaCalificaciones?.headers?.[i]?.valor !== 'Nº' && tablaCalificaciones?.headers?.[i]?.valor !== 'RUT' && tablaCalificaciones?.headers?.[i]?.valor !== 'Nombre' && tablaCalificaciones?.headers?.[i]?.valor !== 'CF' && tablaCalificaciones?.headers?.[i]?.valor !== 'Situación final'"
            >
              <div
                class="col"
                [ngClass]="{ 'mb-3': row.tipoNota === null, 'mt-3': first }"
              >
                <div *ngIf="last" class="mb-3"></div>
                <p class="mx-4">
                  {{ tablaCalificaciones?.headers?.[i]?.valor }}
                </p>
              </div>
              <div
                class="col"
                [ngClass]="{ 'mb-3': row.tipoNota === null, 'mt-3': first }"
              >
                <p class="mx-4 text-right">{{ row.valor }}</p>
              </div>
            </ng-container>

            <div
              class="col-12 mt-3 ocultar-desktop"
              *ngIf="tablaCalificaciones?.headers?.[i]?.valor === 'Anotaciones'"
            >
              <div class="row">
                <div class="col-8 col-sm-9 col-md-10 col-lg-10 ml-4">
                  <div class="form-group overflow-auto">
                    <textarea
                      class="form-control titulo_criterios"
                      id="exampleFormControlTextarea1"
                      rows="2"
                      placeholder="Máx. 150 carácteres"
                      maxlength="150"
                      style="font-size: 1.2rem"
                      [value]="row.valor"
                      [disabled]="!row.editable || !registrosEditables || tablaCalificaciones?.headers?.[i]?.editable === false"
                      (focusout)="focusOut($event, indexBody, i, row, true)"
                    >
                    <!-- (change)="modificarAnotaciones(indexBody, i, row, $event)" -->
                    </textarea>
                  </div>
                </div>
                <div class="col-2 pr-0">
                  <button
                    [disabled]="!registrosEditables"
                    class="boton-secundario tamanio_iconos-boton"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="OK"
                    alt="OK"
                    (click)="guardarCalificaciones()"
                  >
                    <i class="bi bi-check2"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- FIN ALUMNOS -->
  <app-modal-info
    modalId="modal-info"
    [titulo]="infoModalTitulo"
    [texto]="infoModalTexto"
  ></app-modal-info>
  <button
    id="btn-modal-info"
    type="button"
    class="btn btn-primary d-none"
    data-toggle="modal"
    data-target="#modal-info"
  >
    Modal info
  </button>

  <!-- Modal Volver con cambios pendientes -->
  <button
    id="btn-modal-cambios-pendientes"
    type="button"
    class="btn btn-primary d-none"
    data-toggle="modal"
    data-target="#modal-cambios-pendientes"
  >
    Modal info
  </button>

  <div
    class="modal fade"
    id="modal-cambios-pendientes"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header align-items-center">
          <h1 class="modal-title mt-0 ml-4" id="exampleModalLabel">Atención</h1>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            title="CERRAR"
            alt="CERRAR"
          >
            <div class="icono-cerrar mr-3" aria-hidden="true">&times;</div>
          </button>
        </div>

        <div class="modal-body">
          <div class="mb-2">
            <p class="text-left ml-3">
              Hay cambios pendientes que no han sido guardados.
            </p>
            <p class="text-left ml-3">¿Deseas guardar los cambios?</p>
          </div>
        </div>

        <div class="modal-footer justify-content-center text-center">
          <button
            id="btn-guardar-visualizacion-seccion-modal"
            (click)="guardarCalificaciones(true)"
            data-dismiss="modal"
            class="btn boton-primario ml-3 my-2 text-center"
            data-toggle="tooltip"
            data-placement="top"
            title="guardar"
            alt="guardar"
          >
            guardar
          </button>
          <button
            id="modal-cambios-pendientes-close"
            class="boton-secundario boton_secundario_modal text-center mx-3"
            data-toggle="tooltip"
            data-placement="top"
            title="CANCELAR"
            alt="CANCELAR"
            data-dismiss="modal"
          >
            CANCELAR
          </button>
          <button
            (click)="volverAPortal()"
            class="btn no_guardar"
            data-toggle="tooltip"
            data-placement="top"
            title="NO GUARDAR"
            alt="NO GUARDAR"
          >
            NO GUARDAR
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="ocultar-mobile">
    <div
      class="position-fixed bottom-0 left-0 p-3"
      style="z-index: 5; left: 0; bottom: 0"
    >
      <div
        class="toast"
        id="info-calificacion-toast"
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
        data-autohide="false"
      >
        <div class="toast-header custom-toast-header">
          Calificación:
          <strong class="mr-auto ml-1"> {{ infoCalificacion?.tipo }}</strong>
          <button
            type="button"
            class="ml-2 mb-1 close"
            data-dismiss="toast"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="toast-body custom-toast-body">
          <h5>{{ infoCalificacion?.nombreAlumno }}</h5>
          <p class="text-muted">
            <strong>Descripción calificación:</strong>
            {{ infoCalificacion?.descripcion }}
          </p>
          <div *ngIf="infoCalificacion?.alineacion">
            <span>{{infoCalificacion?.alineacion.tipoColumnaBB}}</span>
            <h5>{{infoCalificacion?.alineacion.nombreColumnaBB}}</h5>
            <span>({{infoCalificacion?.alineacion.puntosBB }} Puntos)</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- modal seleccion integracion ponderaciones -->
<div
  class="modal fade"
  id="modal-integracion-bb"
  tabindex="-1"
  role="dialog"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-body pb-4">
        <div class="px-5 py-2 pt-4">
          <div class="header-barra-container">
            <h5 class="header-barra-naranja pb-4">
              Seleccione las columnas de Blackboard que desee integrar
            </h5>
          </div>
          <div
            class="alert alert-warning alert-warning-container tipografía_alertas my-4 animate__fadeIn"
            role="alert"
            *ngIf="deshabilitarSelectAll"
          >
            <i class="bi bi-exclamation-triangle-fill mr-2"></i> Las columnas
            previamente alineadas no están disponibles en Blackboard. Deberás
            volver a configurar la alineación nuevamente.
            <button
              type="button"
              class="close tipografía_alertas"
              data-dismiss="alert"
              aria-label="Close"
              data-toggle="collapse"
              data-target="#collapseWidthExample"
              aria-expanded="true"
              aria-controls="collapseWidthExample"
            >
              <span aria-hidden="true" class="alert-warning">&times;</span>
            </button>
          </div>
          <p class="leyenda-integracion" 
          *ngIf="deshabilitarSelectAll">
            Puede volver a realizar alineación o seguir integrando con las columnas disponibles.
          </p>
          <div class="contenedor-gris" *ngIf="ponderacionesAlineacionBb">
            <div class="contenedor-ponderaciones">
              <div class="d-flex mt-4">
                <div class="w-50">
                  <div class="item-integracion-blackboard item-seccion">
                    <div class="item-header">
                      <p>Sección:</p>
                      <p>
                        <b>{{ ponderacionesAlineacionBb.seccion }}</b>
                      </p>
                    </div>
                    <div class="item-body">
                      <p><b>Evaluaciones de Portal de Calificaciones</b></p>
                    </div>
                  </div>
                </div>
                <div class="w-50">
                  <div class="item-integracion-blackboard item-integracion">
                    <div class="item-header">
                      <p><b>Integración</b></p>
                    </div>
                    <div class="item-body">
                      <p><b>Evaluaciones Seleccionadas de Blackboard</b></p>
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-check cstm-checkbox">
                <input
                  class="form-check-input"
                  type="checkbox"
                  value=""
                  id="seleccionarTodos"
                  (click)="seleccionarTodos($event)"
                  [disabled]="deshabilitarSelectAll"
                  [checked]="arrPonderacionesSincronizacionBb.length === ponderacionesAlineacionBb.columnas.length"
                />
                <label class="form-check-label" for="seleccionarTodos">
                  Seleccionar todos
                </label>
              </div>

              <!-- Ponderaciones de bb -->
              <div class="contenedor-ponderaciones">
                <div
                  class="d-flex mt-4 position-relative"
                  *ngFor="let ponderacion of ponderacionesAlineacionBb.columnas; let indexPonderacion = index"
                >
                  <div class="form-check cstm-checkbox inner-checkbox">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      [id]="ponderacion.bbColumnaId"
                      (click)="
                        toggleAlineacion(ponderacion.bbColumnaId, $event)
                      "
                      *ngIf="ponderacion.encontradaBb"
                    />
                    <div *ngIf="!ponderacion.encontradaBb" class="d-flex">
                      <div id="icono-periodo">
                        <i
                          class="bi bi-exclamation-triangle"
                          [ngStyle]="{
                            'margin-left': '-14px',
                            'font-size': '17px'
                          }"
                        ></i>
                      </div>
                      <div class="triangle triangle-columna"></div>
                      <div
                        [id]="'cstm-popover'"
                        class="cstm-popover cstm-popover-columna"
                      >
                        La columna previamente alineada,<br />no se encuentra
                        disponible en Blackboard.
                      </div>
                    </div>
                  </div>
                  <div class="w-50">
                    <div
                      class="item-ponderacion-container item-ponderacion-seccion"
                      [ngClass]="{
                        'item-ponderacion-container-disabled':
                          !ponderacion.encontradaBb
                      }"
                    >
                      <p class="mb-0">
                        {{ ponderacion.tipoNota }}{{ ponderacion.nroNota }} ({{
                          ponderacion.porcentaje
                        }}%)
                      </p>
                    </div>
                  </div>
                  <div class="w-50">
                    <div
                      class="item-ponderacion-container item-detalle-integracion"
                      [ngClass]="{
                        'item-ponderacion-container-disabled':
                          !ponderacion.encontradaBb
                      }"
                      (mouseenter)="togglePopoverDetalleBb('item-detalle-integracion-popover-'+indexPonderacion, true)"
                      (mouseleave)="togglePopoverDetalleBb('item-detalle-integracion-popover-'+indexPonderacion, false)"
                    >
                      <p class="mb-0">{{ ponderacion.nombreColumnaBB }}</p>
                      <div class="item-detalle-integracion-popover d-none" [id]="'item-detalle-integracion-popover-'+indexPonderacion">
                        <p>{{ ponderacion.tipoColumnaBB }}</p>
                        <p>{{ ponderacion.nombreColumnaBB }}</p>
                        <p>({{ ponderacion.puntosBB }} Puntos)</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="mb-4 pt-4 float-right">
            <button
              id="modal-integracion-bb-close"
              class="boton-secundario boton_secundario_modal ml-3"
              data-toggle="tooltip"
              data-placement="top"
              title="Cerrar"
              alt="Cerrar"
              data-dismiss="modal"
            >
              Cerrar
            </button>
            <button
              class="boton-primario boton-primario_modal bg-confirmar-seleccion ml-3"
              data-placement="top"
              title="Confirmar selección"
              alt="Confirmar"
              (click)="confirmarAlineacion()"
              [disabled]="this.arrPonderacionesSincronizacionBb.length === 0"
            >
              Obtener calificaciones
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<button
  id="btn-modal-integracion-bb"
  type="button"
  class="btn btn-primary d-none"
  data-toggle="modal"
  data-target="#modal-integracion-bb"
>
  Modal info
</button>
<!-- fin modal seleccion integracion ponderaciones -->

<!-- modal seleccion fechas evaluaciones -->
<div
  class="modal fade"
  id="fechaEvaluaciones"
  tabindex="-1"
  role="dialog"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
  data-backdrop="static"
  data-keyboard="false"
>
  <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-body pb-4">
        <div class="px-5 py-2 pt-4">
          <h5 class="header-barra-naranja pb-4">
            Seleccione las calificaciones una por una y marque sus fechas
            correspondientes en el calendario
          </h5>
          <button
            class="close-x"
            (click)="cerrarModalFechas()"
            aria-label="Cerrar"
          >
            ✕
          </button>
        </div>
        <!-- here el formulario fechas evaluaciones  -->
        <div class="container-fechas">
          <div class="container-fechas__list">
            <div
              class="eval-item"
              *ngFor="let ev of datosListaEvaluaciones; let i = index"
              [class.is-selected]="ev.isSelected"
            >
              <label class="eval-item__row">
                <input
                  type="checkbox"
                  class="cstm-checkbox"
                  [checked]="selectedIndex === i"
                  (change)="onSelectEvaluacion(i)"
                  [ngClass]="{
                    'chk--con-fecha':
                      selectedIndex === i && !!fechasDraft[i].fecha,
                    'chk--nuevo': selectedIndex === i && !fechasDraft[i].fecha
                  }"
                  [attr.aria-label]="'Seleccionar ' + ev.nombre"
                  [disabled]="!ev.isEditable"
                />
                <span class="pill" [class.is-NotEditable]="!ev.isEditable">
                  <p>{{ ev.sigla }}</p>
                  <p>({{ ev.porcentaje }}%)</p>
                </span>
                <div
                  class="eval-item__text"
                  [class.is-NotEditable]="!ev.isEditable"
                >
                  <div class="eval-item__title">Actividad</div>
                  <div class="eval-item__desc">
                    {{ ev.nombre }} {{ ev.descripcion }}
                  </div>
                </div>
                <div class="eval-item__date" *ngIf="ev.fecha">
                  {{ ev.fecha }}
                </div>
              </label>
              <div class="eval-item__divider"></div>
            </div>
          </div>
          <!-- Columna derecha: datepicker -->
          <div class="container-fechas__calendar card-like">
            <mat-calendar
              #cal
              [selected]="selectedDate"
              (selectedChange)="onCalendarChange($event)"
            >
            </mat-calendar>
            <div class="flex-content">
              <button
                class="btn container-btn-confirm mt-2"
                [disabled]="selectedIndex === null || !selectedDate"
                (click)="confirmarFecha()"
              >
                CONFIRMAR FECHA
              </button>
            </div>
          </div>
        </div>
        <div class="mb-4 mt-buttons-modal float-right">
          <button
            id="modal-fechaEvaluaciones-close"
            class="d-none"
            data-toggle="tooltip"
            data-placement="top"
            title="Cerrar"
            data-dismiss="modal"
          >
            -
          </button>
          <button
            class="boton-secundario boton_secundario_modal ml-3"
            (click)="cerrarModalFechas()"
          >
            Cerrar
          </button>
          <button
            class="boton-primario boton-primario_modal bg-confirmar-seleccion ml-3"
            data-placement="top"
            title="Guardar"
            alt="Confirmar"
            [disabled]="selectedIndex === null || !selectedDate"
            (click)="guardarModalFechas()"
          >
            Guardar
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- FIN modal seleccion fechas evaluaciones -->

<!-- modal integracion calificaciones cargadas -->
<div
  class="modal fade"
  id="modal-calificaciones-cargadas"
  tabindex="-1"
  role="dialog"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
>
  <div
    class="modal-dialog modal-dialog-calificaciones-cargadas modal-dialog-centered"
    role="document"
  >
    <div class="modal-content">
      <div class="modal-body pb-4 contenido-calificaciones-cargadas">
        <div class="contenedor-contenido-calificaciones-cargadas">
          <p>
            Las columnas de Blackboard han sido integradas y se han cargado las
            calificaciones correspondientes.
          </p>
          <p>Puede continuar calificando de forma manual si así lo requiere.</p>
          <p>
            Si se realiza un cambio en Blackboard, las calificaciones integradas
            con Portal de Calificaciones no se actualizarán automáticamente.
            Deberá realizar el proceso de integración nuevamente.
          </p>
        </div>

        <div class="modal-footer justify-content-center">
          <button
            id="modal-calificaciones-cargadas-close"
            class="boton-secundario boton_secundario_modal bg-btn-entendido ml-3"
            data-toggle="tooltip"
            data-placement="top"
            title="Entendido"
            alt="Entendido"
            data-dismiss="modal"
          >
            Entendido
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<button
  id="btn-modal-calificaciones-cargadas"
  type="button"
  class="btn btn-primary d-none"
  data-toggle="modal"
  data-target="#modal-calificaciones-cargadas"
>
  Modal info
</button>
<!-- fin modal integracion calificaciones cargadas -->

<div
  class="modal fade"
  id="modal-calificaciones-error"
  tabindex="-1"
  role="dialog"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
>
  <div
    class="modal-dialog modal-dialog-calificaciones-cargadas modal-dialog-centered"
    role="document"
  >
    <div class="modal-content">
      <div class="modal-body pb-4 contenido-calificaciones-cargadas">
        <div
          class="contenedor-contenido-calificaciones-cargadas integracion-calificaciones-error"
        >
          <p>
            {{ mensajeError }}
          </p>
        </div>

        <div class="modal-footer justify-content-center">
          <button
            id="modal-calificaciones-error-close"
            class="boton-secundario boton_secundario_modal bg-btn-entendido ml-3"
            data-toggle="tooltip"
            data-placement="top"
            title="Aceptar"
            alt="Aceptar"
            data-dismiss="modal"
          >
            Aceptar
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<button
  id="btn-modal-calificaciones-error"
  type="button"
  class="btn btn-primary d-none"
  data-toggle="modal"
  data-target="#modal-calificaciones-error"
>
  Modal info
</button>
